import React from 'react';
import { LFC } from '../../../Legacy';
import { StoreState } from '../../../concepts/revive/Store';
import { Counter } from '../../common/Users';
import { Participant } from './Participant';

export type ParticipantCounterProps = {
    info: Pick<StoreState<Participant>, 'name' | 'color' | 'photo'>,
    size?: number,
    unit?: string,
    clickable?: boolean,
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ParticipantCounter: LFC<ParticipantCounterProps> = ({ info, children, ...rest }) => {
    return <Counter {...rest as any} title={info.name} color={info.color} photo={info.photo} >
        {Participant.toInitials(info.name)}
    </Counter>;
};


